// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__23Lxc","header":"ReportDetails_header__1Y7LO","title":"ReportDetails_title__3fnIj","left":"ReportDetails_left__3PDY_"};